import React from 'react'
import { Donate } from 'components/blocks'

export default function Footer({ pageIsDonate }) {
  return (
    <div className="bg-black">
      {!pageIsDonate && <Donate />}
      <div className="w-11/12 mx-auto container py-6">
        <div className="text-center">
          <p className="font-medium uppercase text-xl text-gold">
            INDUSTRY INQUIRIES: <br className="md:hidden" />
            <a
              className="underline break-words"
              href="mailto:Info@dorothydandridgemusical.com "
            >
              Info@dorothydandridgemusical.com
            </a>
          </p>
          <p className="text-white font-medium mt-2 pb-[2px]">
            &copy; 2023 Dorothy Dandridge LLC
          </p>
          <p className="text-white font-medium">
            Dorothy Dandridge! The Musical
          </p>
        </div>
      </div>
    </div>
  )
}
